import { Col, Row } from "react-bootstrap";
import React from "react";
import { s3_url } from "common/constants";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import usePageTitle from "common/usePageTitle";

function AboutPage() {
  const startImageNum = 8;
  const endImageNum = 21;
  const images = [];

  usePageTitle("O nama");

  for (let i = startImageNum; i <= endImageNum; i++) {
    images.push({ original: `${s3_url}/img/${i}.webp` });
  }

  return (
    <div>
      <h1>O nama</h1>
      <hr />
      <Row className="mb-3">
        <Col className="d-flex align-items-center">
          <div>
            <p className="lead">
              Naša priča započela je prije 30 godina kada je Karmen Bljaić,
              profesorica matematike i fizike odlučila svoju ljubav prema
              matematici i fizici te djeci i podukama prenijeti učenicima kroz
              osnivanje škole za poduke Lumen. Svaki početak je težak, pa se
              tako i Karmen susrela s mnogim preprekama, ali bila je ustrajna u
              svom cilju. Kada radiš ono što voliš, svaki problem ima rješenje,
              a Karmen zaista radi posao koji voli!
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} order={1} className="d-flex align-items-center mb-1">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/1.webp`}
            style={{ width: "90%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>

        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/2.webp`}
            style={{ width: "90%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>
      <Row className="my-5">
        <Col md={6} order={1} className="d-flex align-items-center mb-1">
          <p className="lead">
            Kroz život je uvijek lakše koračati s nekim, stoga nagovara svoju
            sestru Jasnu da joj se pridruži. Na sreću posao raste iz dana u dan
            te Jasna marljivo vodi računa o svim logističkim i organizacijskim
            poslovima ove Lumen obitelji. Jasna će pronaći najbolji termin za
            svakog učenika, dočekat ga s osmijehom i čokoladicom te ga ohrabriti
            lijepom riječi, prije nego krene s našim nastavnicima u borbu s
            teškim nastavnim sadržajima. Zaposlenici Lumen obitelji zovu je naša
            najdraža „tajnica“ i iz njezine kancelarije uvijek se čuje smijeh.
          </p>
        </Col>
        <Col md={6} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/3.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col></Col>
        <p className="lead">
          Kako posao raste, tako se širi i Lumen obitelj. Svoje prve prostore na
          Kantridi zamjenjuju prostorima u centru grada Rijeke. Kroz godine, na
          vrata Lumena, na adresi Fiorella la Guardije 12, Rijeka pokucalo je
          nebrojeno generacija pripremajući se za ispite iz raznih predmeta,
          savladavajući gradivo, pripremajući se za državnu maturu. Tako je
          obitelj Lumena iz godine u godinu rasla. Kvaliteta i rad se prepoznaju
          pa je tako Karmen više godina zaredom proglašena jednom od
          najuspješnijih poduzetnica u toj godini.
        </p>
      </Row>
      <Row>
        <Col md={4} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/4.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={4} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/5.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
        <Col md={4} order={1} className="d-flex align-items-center">
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/6.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>
      <Row className="my-5">
        <Col md={6} className="d-flex align-items-center">
          <p className="lead">
            Dokaz da smo svi zajedno velika Lumen obitelj je i sama činjenica da
            su mnogi učenici Lumena postali nastavnici Lumena. Ponovno je
            pokucala na naša vrata 2015. godine Mia Černivec, sada u ulozi
            profesorice matematike i informatike. Mlada profesorica, puna novih
            ideja, unijela je novu energiju u naš tim. Krenuli smo u
            modernizaciju radnih materijala i sve više se okrenuli digitalnom
            dobu. Upravo ona će voditi projekt Lumen@home i biti vam podrška na
            našoj web platformi.
          </p>
        </Col>
        <Col md={6}>
          <img
            className="featurette-image img-fluid mx-auto"
            src={`${s3_url}/img/7.webp`}
            style={{ width: "100%" }}
            alt="Lumen logo"
            loading="lazy"
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <p className="lead">
            Obzirom na to da obitelj nije propisana formulama, jednadžbama,
            periodnim sustavom elementa ili mjestom stanovanja, Karmen je sa
            svojim timom nastavnika odlučila svoju priču proširiti na cijelu
            Hrvatsku pružajući učenicima mogućnost online pripreme za državnu
            maturu kroz projekt Lumen@home, čime ih poziva u jednu veliku,
            nasmijanu obitelji punu podrške koja postoji već 30 godina.
          </p>
        </Col>
      </Row>

      <div className="mb-3">
        <ImageGallery items={images} />
      </div>
    </div>
  );
}

export default AboutPage;
